module.exports = __webpack_public_path__ + "static/media/header.c92ed4d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/customerexpert/landingpage/header.jpg
// module id = 1618
// module chunks = 0